import axios from 'axios';
//axios.defaults.withCredentials=true;
import qs from 'qs'
import {
  Message
} from 'element-ui';
axios.defaults.timeout = 300000; //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'; //配置请求头
// axios.defaults.baseURL ="http://www.realgamecloud.com/";//"http://t.xiehou360.com/DollPubAppServer/";// httpUtils.getBaseUrl();httpUtils.getBaseUrl(); //配置接口地址
// export default axios;

axios.interceptors.request.use((config) => {
  //在发送请求之前做某件事
  if (config.method === 'post') {
    config.data = JSON.stringify(config.data);
  }
  // console.log('config===========',config);
  config.headers.sid = localStorage.getItem("sid") || '';
  return config;
}, (error) => {
  console.info("错误的传参", 'fail');
  return Promise.reject(error);
});

axios.interceptors.response.use(response => {
  return response

}, error => {
  console.log(error.response)
  if (error.response) {
    if (error.response.status) {
      return Message({
        message: 'Bad Request',
        type: 'warning',
        duration: 1000
      });
    }
  }
})


function fetchpost(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
};

function fetchget(url) {
  return new Promise((resolve, reject) => {
    axios.get(url)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default {
  fetchpost,
  fetchget
}



// WEBPACK FOOTER //
// ./src/comm/js/axios_config.js